import { all } from "./async-saga";
import auth from "./auth";
import channelConnections from "./channelConnections";

export default all(
    auth,
    channelConnections
)